import React from 'react';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import TimerOutlinedIcon from '@material-ui/icons/TimerOutlined';

import { formatScheduledDate } from '../../domain';
import type { ScheduledOrder } from '../../domain';

import { useSOCardLang } from './hooks';

import makeClasses from './SOCard.style';

interface Props {
  order: ScheduledOrder;
  onClick?: (order: ScheduledOrder) => void;
}

export function SOCard({ order, onClick }: Props) {
  const _classes = makeClasses();
  const lang = useSOCardLang();

  return (
    <button
      type='button'
      className={_classes.root}
      onClick={() => onClick?.(order)}
    >
      <div className={_classes.header}>
        <div className={_classes.identity}>
          <p className={_classes.orderId}>
            {`${lang.orderIdLabel} ${order.orderId}`}
          </p>
          <p className={_classes.storeName} title={order.storeName}>
            {order.storeName}
          </p>
        </div>

        <span className={_classes.tag}>
          <DateRangeOutlinedIcon className={_classes.tagIcon} />
          {lang.scheduledTag}
        </span>
      </div>

      <div className={_classes.dateRow}>
        <TimerOutlinedIcon className={_classes.dateIcon} />
        <p className={_classes.dateValue}>
          {formatScheduledDate(order.placeAt)}
        </p>
      </div>
    </button>
  );
}
